export enum OverrideEntity {
  Users = 'users',
  Streams = 'streams'
}
